import { useMemo } from 'react';

import { useEnemyStore } from './game.store';

/************************************
 * This file contains helpful hooks that we can use throughout the game
 ************************************/

/**
 * Checks if all enemies are dead.
 * @returns {boolean} True if all enemies are dead, false otherwise.
 */
export const useAreAllEnemiesDead = () => {
   const { state } = useEnemyStore();
   return Object.values(state.enemies).every((enemy) => enemy.isDead);
};

/**
 * Custom hook to select an enemy from the enemy store.
 *
 * @param params - The parameters for selecting the enemy.
 * @param params.enemyId - The ID of the enemy to select.
 * @returns The selected enemy from the enemy store.
 */
export const useSelectEnemy = (params: { enemyId: string }) => {
   const { state } = useEnemyStore();
   return useMemo(() => state.enemies[params.enemyId], [state, params]);
};
